import getters from "./getters";
import mutations from "./mutations";
import Store from "./Store";
import actions from "./actions";

class VuexStore {
    constructor(
        public namespaced: boolean = true,
        public state: Store,
        public getters: any,
        public mutations: any,
        public actions: any
    ) {}
}

export default new VuexStore(true, new Store(), getters, mutations, actions);
